import React, { useState } from "react";
import axios from "axios";

const MyProfile = () => {
  // State for form data
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    personalEmail: "",
    workEmail: "",
    phone: "",
    birthdate: "",
    gender: "",
    pincode: "",
    city: "",
    state: "",
    country: "",
    highestEducation: "",
    annualEarnings: "",
    mailingAddress: "",
    skills: [""],
    workStatus: "",
    professionType: "",
    jobTitle: "",
    companyName: "",
    totalWorkExperience: "",
    seniorityLevel: "",
    jobResponsibility: "",
    currentCompanyTenure: "",
    sector: "",
    industry: "",
    businessModel: "",
    companyRevenue: "",
    headquartersLocation: "",
    linkedinPage: "",
    specialties: "",
    aboutCompany: "",
    previousEmployers: [
      {
        companyName: "",
        jobTitle: "",
        fromDate: "",
        toDate: "",
        location: "",
        jobDescription: "",
      },
    ],
  });

  // Inside MyProfile component, add state for modal input
  const [newSkill, setNewSkill] = useState("");
  const [isSkillsModalOpen, setIsSkillsModalOpen] = useState(false);

  // Suggested skills (hardcoded, replace with API data if needed)
  const suggestedSkills = [
    "UI Design",
    "UX Research",
    "Prototyping",
    "Figma",
    "Adobe XD",
    "Communication",
  ];

  // Modified addSkill function to open modal
  const addSkill = () => {
    setNewSkill(""); // Reset input when opening modal
    setIsSkillsModalOpen(true);
  };

  // Function to handle saving a skill
  const saveSkill = (skill) => {
    if (
      skill &&
      !formData.skills.includes(skill) &&
      formData.skills.length < 45
    ) {
      setFormData({ ...formData, skills: [...formData.skills, skill] });
    }
    setIsSkillsModalOpen(false);
  };

  // Function to handle selecting a suggested skill
  const selectSuggestedSkill = (skill) => {
    if (!formData.skills.includes(skill) && formData.skills.length < 45) {
      setFormData({ ...formData, skills: [...formData.skills, skill] });
    }
    setIsSkillsModalOpen(false);
  };

  // State for current step (1, 2, or 3)
  const [currentStep, setCurrentStep] = useState(0);

  // State for loading and error
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Handle input changes
  const handleChange = (e, index, field, arrayName) => {
    if (arrayName) {
      // Handle array fields (skills or previousEmployers)
      const updatedArray = [...formData[arrayName]];
      updatedArray[index] =
        arrayName === "skills"
          ? e.target.value
          : { ...updatedArray[index], [field]: e.target.value };
      setFormData({ ...formData, [arrayName]: updatedArray });
    } else {
      // Handle simple fields
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  // Add a new skill
  // const addSkill = () => {
  //   setFormData({ ...formData, skills: [...formData.skills, ''] });
  // };

  // Add a new previous employer
  const addEmployer = () => {
    setFormData({
      ...formData,
      previousEmployers: [
        ...formData.previousEmployers,
        {
          companyName: "",
          jobTitle: "",
          fromDate: "",
          toDate: "",
          location: "",
          jobDescription: "",
        },
      ],
    });
  };

  // Remove a previous employer
  const removeEmployer = (index) => {
    setFormData({
      ...formData,
      previousEmployers: formData.previousEmployers.filter(
        (_, i) => i !== index
      ),
    });
  };

  // Handle form submission (submit or draft)
  const handleSubmit = async (event, status) => {
    if (event) event.preventDefault();
    setLoading(true);
    setError("");

    try {
      // Basic validation
      if (currentStep === 0 && !formData.firstName) {
        throw new Error("First Name is required");
      }

      const payload = {
        ...formData,
        status: status, // 1 for submit, 2 for draft
      };

      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/profile/create`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        alert(
          status === 1
            ? "Profile submitted successfully!"
            : "Profile saved as draft!"
        );
        // Reset form
        setFormData({
          firstName: "",
          lastName: "",
          personalEmail: "",
          workEmail: "",
          phone: "",
          birthdate: "",
          gender: "",
          pincode: "",
          city: "",
          state: "",
          country: "",
          highestEducation: "",
          annualEarnings: "",
          mailingAddress: "",
          skills: [""],
          workStatus: "",
          professionType: "",
          jobTitle: "",
          companyName: "",
          totalWorkExperience: "",
          seniorityLevel: "",
          jobResponsibility: "",
          currentCompanyTenure: "",
          sector: "",
          industry: "",
          businessModel: "",
          companyRevenue: "",
          headquartersLocation: "",
          linkedinPage: "",
          specialties: "",
          aboutCompany: "",
          previousEmployers: [
            {
              companyName: "",
              jobTitle: "",
              fromDate: "",
              toDate: "",
              location: "",
              jobDescription: "",
            },
          ],
        });
        setCurrentStep(1);
      } else {
        alert("Error processing profile. Please try again.");
      }
    } catch (err) {
      console.error("Profile Creation Error:", err);
      setError(err.message || "Failed to process profile. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Handle navigation between steps
  const goToNextStep = () => {
    if (currentStep < 2) setCurrentStep(currentStep + 1);
  };

  const goToPreviousStep = () => {
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  };

  return (
    <div id="wrapper">
      <section id="profilebanner" class="d-flex py-5"></section>
      <section id="profile_inner_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="inner_wrapper card_box py-5">
                <div className="profileinnerbox">
                  <div className="pr_heading">
                    <h2>Let’s get you started</h2>
                    <p>
                      Lorem ipsum dolor sit amet. In iste dignissimos in
                      repellendus
                    </p>
                  </div>

                  <form
                    onSubmit={(e) => handleSubmit(e, 0)}
                    className="profile-form"
                  >
                    {/* Progress Bar */}
                    <div className="profile-progress-bar">
                      <div
                        className="profile-progress"
                        style={{ width: `${(currentStep / 2) * 100}%` }}
                      ></div>
                      <div
                        className={`profile-progress-step ${
                          currentStep >= 0 ? "active" : ""
                        }`}
                        data-title="Personal & Basic Details"
                      >
                        <span>Personal & Basic Details</span>
                      </div>
                      <div
                        className={`profile-progress-step ${
                          currentStep >= 1 ? "active" : ""
                        }`}
                        data-title="Career & Current Organization"
                      >
                        <span>Career & Current Organization</span>
                      </div>
                      <div
                        className={`profile-progress-step ${
                          currentStep >= 2 ? "active" : ""
                        }`}
                        data-title="Previous Employers (Optional)"
                      >
                        <span>Previous Employers (Optional)</span>
                      </div>
                    </div>

                    {/* Step One */}
                    <div
                      className={`stepone ${currentStep === 0 ? "active" : ""}`}
                    >
                      <div className="row g-4">
                        <div className="col-md-6">
                          <label htmlFor="firstName" className="form-label">
                            First Name
                          </label>
                          <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            className="form-control"
                            placeholder="Enter Your First Name"
                            value={formData.firstName}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="lastName" className="form-label">
                            Last Name
                          </label>
                          <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            className="form-control"
                            placeholder="Enter Your Last Name"
                            value={formData.lastName}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="personalEmail" className="form-label">
                            Personal Email
                          </label>
                          <input
                            type="email"
                            id="personalEmail"
                            name="personalEmail"
                            className="form-control"
                            placeholder="Enter Your Personal Email"
                            value={formData.personalEmail}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="workEmail" className="form-label">
                            Work Email
                          </label>
                          <input
                            type="email"
                            id="workEmail"
                            name="workEmail"
                            className="form-control"
                            placeholder="Enter Your Work Email"
                            value={formData.workEmail}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="phone" className="form-label">
                            Mobile Number
                          </label>
                          <input
                            type="tel"
                            id="phone"
                            name="phone"
                            className="form-control"
                            placeholder="Enter Your Mobile Number"
                            value={formData.phone}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="birthdate" className="form-label">
                            Date of Birth
                          </label>
                          <input
                            type="date"
                            id="birthdate"
                            name="birthdate"
                            className="form-control"
                            placeholder="Enter Your Date of Birth"
                            value={formData.birthdate}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="gender" className="form-label">
                            Gender
                          </label>
                          <select
                            id="gender"
                            name="gender"
                            className="form-control selectarrow"
                            value={formData.gender}
                            onChange={(e) => handleChange(e)}
                          >
                            <option value="" disabled hidden>
                              Select Your Gender
                            </option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="pincode" className="form-label">
                            Pincode
                          </label>
                          <input
                            type="text"
                            id="pincode"
                            name="pincode"
                            className="form-control"
                            placeholder="Enter Your Pincode"
                            value={formData.pincode}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="city" className="form-label">
                            City
                          </label>
                          <input
                            type="text"
                            id="city"
                            name="city"
                            className="form-control"
                            placeholder="Enter Your City"
                            value={formData.city}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="state" className="form-label">
                            State
                          </label>
                          <select
                            id="state"
                            name="state"
                            className="form-control selectarrow"
                            value={formData.state}
                            onChange={(e) => handleChange(e)}
                          >
                            <option value="" disabled hidden>
                              Select Your State
                            </option>
                            <option value="delhi">Delhi</option>
                            <option value="noida">Noida</option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="country" className="form-label">
                            Country
                          </label>
                          <select
                            id="country"
                            name="country"
                            className="form-control selectarrow"
                            value={formData.country}
                            onChange={(e) => handleChange(e)}
                          >
                            <option value="" disabled hidden>
                              Select Your Country
                            </option>
                            <option value="India">India</option>
                            <option value="USA">USA</option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label
                            htmlFor="highestEducation"
                            className="form-label"
                          >
                            Highest Education
                          </label>
                          <select
                            id="highestEducation"
                            name="highestEducation"
                            className="form-control selectarrow"
                            value={formData.highestEducation}
                            onChange={(e) => handleChange(e)}
                          >
                            <option value="" disabled hidden>
                              Select Your Highest Education
                            </option>
                            <option value="Bachelor's degree">
                              Bachelor's degree
                            </option>
                            <option value="Master's degree">
                              Master's degree
                            </option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label
                            htmlFor="annualEarnings"
                            className="form-label"
                          >
                            Annual Earnings <span>(Optional)</span>
                          </label>
                          <input
                            type="text"
                            id="annualEarnings"
                            name="annualEarnings"
                            className="form-control"
                            placeholder="Enter Your Annual Earnings"
                            value={formData.annualEarnings}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label
                            htmlFor="mailingAddress"
                            className="form-label"
                          >
                            Mailing Address
                          </label>
                          <input
                            type="text"
                            id="mailingAddress"
                            name="mailingAddress"
                            className="form-control"
                            placeholder="Enter Your Mailing Address"
                            value={formData.mailingAddress}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        {/* Updated skills section in the form (inside stepone) */}
                        <div className="col-md-12">
                          <label className="form-label">Skills</label>
                          <div className="skillsadd">
                            {formData.skills.map((skill, index) => (
                              <div key={index} className="d-flex mb-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Your Skill"
                                  value={skill}
                                  readOnly // Make skills read-only to prevent direct editing
                                />
                              </div>
                            ))}
                            <div className="addmoreskills" onClick={addSkill}>
                              <i className="bi bi-plus-square-fill"></i>
                            </div>
                          </div>

                          {/* Skills Modal (inline) */}
                         {/* {JSON.stringify(isSkillsModalOpen === true)} */}
                          {isSkillsModalOpen && (
                            <>
                            {/* <h1> this is modal</h1> */}
                              {/* Overlay */}
                              <div className="addmoreskills-overlay"></div>
                              {/* Modal Popup */}
                              <div
                                className="addmoreskillsbox"
                                id="addmoreskillsModal"
                              >
                                <button
                                  id="closeModal"
                                  onClick={() => setIsSkillsModalOpen(false)}
                                >
                                  <i className="bi bi-x-lg"></i>
                                </button>

                                <h5 className="fw-500 ft-24 mb-4">Add skill</h5>

                                <div className="skillsaddrow">
                                  <div className="position-relative search_aside">
                                    <label className="fw-500 ft-15 mb-3">
                                      Skills
                                    </label>
                                    <div className="skillssearch">
                                      <i className="bi bi-search"></i>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Skill (ex: UI/UX Designer)"
                                        value={newSkill}
                                        onChange={(e) =>
                                          setNewSkill(e.target.value)
                                        }
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            e.preventDefault();
                                            saveSkill(newSkill);
                                          }
                                        }}
                                      />
                                    </div>
                                    <p className="ft-14 fw-400 color858c95 mt-2">
                                      You can add {45 - formData.skills.length}{" "}
                                      more skills
                                    </p>
                                  </div>
                                </div>

                                <div className="skillslist mt-5">
                                  <p className="mb-3 ft-15 fw-500">
                                    Suggested based on your profile
                                  </p>
                                  <ul>
                                    {suggestedSkills.map((skill, index) => (
                                      <li
                                        key={index}
                                        onClick={() =>
                                          selectSuggestedSkill(skill)
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        {skill}
                                      </li>
                                    ))}
                                  </ul>
                                </div>

                                <div className="d-flex justify-content-end mt-5">
                                  <div className="d-flex gap-3">
                                    <button
                                      className="btn btn-dark text-decoration-none create_survey rounded-3 ft-15"
                                      // onClick={() => saveSkill(newSkill)}
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="d-flex justify-content-center mt-5">
                        <button
                          type="button"
                          className="btn btn-dark text-decoration-none create_survey rounded-3 ft-15"
                          onClick={goToNextStep}
                          disabled={loading}
                        >
                          Next
                        </button>
                      </div>
                    </div>

                    {/* Step Two */}
                    <div
                      className={`steptwo ${currentStep === 1 ? "active" : ""}`}
                    >
                      <div className="row g-4">
                        <div className="col-md-6">
                          <label htmlFor="workStatus" className="form-label">
                            Work Status
                          </label>
                          <select
                            id="workStatus"
                            name="workStatus"
                            className="form-control selectarrow"
                            value={formData.workStatus}
                            onChange={(e) => handleChange(e)}
                          >
                            <option value="" disabled hidden>
                              Select Your Work Status
                            </option>
                            <option value="WorkStatusone">Work Status 1</option>
                            <option value="WorkStatustwo">Work Status 2</option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label
                            htmlFor="professionType"
                            className="form-label"
                          >
                            Profession Type
                          </label>
                          <select
                            id="professionType"
                            name="professionType"
                            className="form-control selectarrow"
                            value={formData.professionType}
                            onChange={(e) => handleChange(e)}
                          >
                            <option value="" disabled hidden>
                              Select Your Profession Type
                            </option>
                            <option value="professiontypeone">
                              Profession Type 1
                            </option>
                            <option value="professiontypetwo">
                              Profession Type 2
                            </option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="jobTitle" className="form-label">
                            Job Title
                          </label>
                          <input
                            type="text"
                            id="jobTitle"
                            name="jobTitle"
                            className="form-control"
                            placeholder="Enter Your Job Title"
                            value={formData.jobTitle}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="companyName" className="form-label">
                            Company Name
                          </label>
                          <input
                            type="text"
                            id="companyName"
                            name="companyName"
                            className="form-control"
                            placeholder="Enter Your Company Name"
                            value={formData.companyName}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label
                            htmlFor="totalWorkExperience"
                            className="form-label"
                          >
                            Total Work Experience
                          </label>
                          <input
                            type="text"
                            id="totalWorkExperience"
                            name="totalWorkExperience"
                            className="form-control"
                            placeholder="Enter Your Total Work Experience"
                            value={formData.totalWorkExperience}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label
                            htmlFor="seniorityLevel"
                            className="form-label"
                          >
                            Seniority Level
                          </label>
                          <select
                            id="seniorityLevel"
                            name="seniorityLevel"
                            className="form-control selectarrow"
                            value={formData.seniorityLevel}
                            onChange={(e) => handleChange(e)}
                          >
                            <option value="" disabled hidden>
                              Select Your Seniority Level
                            </option>
                            <option value="senioritylevelone">
                              Seniority Level 1
                            </option>
                            <option value="seniorityleveltwo">
                              Seniority Level 2
                            </option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label
                            htmlFor="jobResponsibility"
                            className="form-label"
                          >
                            Job Responsibility <span>(Optional)</span>
                          </label>
                          <input
                            type="text"
                            id="jobResponsibility"
                            name="jobResponsibility"
                            className="form-control"
                            placeholder="Enter Your Job Responsibility (Optional)"
                            value={formData.jobResponsibility}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label
                            htmlFor="currentCompanyTenure"
                            className="form-label"
                          >
                            Tenure in Current Company
                          </label>
                          <input
                            type="date"
                            id="currentCompanyTenure"
                            name="currentCompanyTenure"
                            className="form-control"
                            placeholder="Enter Your Tenure in Current Company"
                            value={formData.currentCompanyTenure}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="sector" className="form-label">
                            Sector
                          </label>
                          <select
                            id="sector"
                            name="sector"
                            className="form-control selectarrow"
                            value={formData.sector}
                            onChange={(e) => handleChange(e)}
                          >
                            <option value="" disabled hidden>
                              Select Your Sector
                            </option>
                            <option value="Sectorone">Sector 1</option>
                            <option value="Sectortwo">Sector 2</option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="industry" className="form-label">
                            Industry
                          </label>
                          <select
                            id="industry"
                            name="industry"
                            className="form-control selectarrow"
                            value={formData.industry}
                            onChange={(e) => handleChange(e)}
                          >
                            <option value="" disabled hidden>
                              Select Your Industry
                            </option>
                            <option value="Industryone">Industry 1</option>
                            <option value="Industrytwo">Industry 2</option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="businessModel" className="form-label">
                            Business Model
                          </label>
                          <select
                            id="businessModel"
                            name="businessModel"
                            className="form-control selectarrow"
                            value={formData.businessModel}
                            onChange={(e) => handleChange(e)}
                          >
                            <option value="" disabled hidden>
                              Select Your Business Model
                            </option>
                            <option value="businessmodelone">
                              Business Model 1
                            </option>
                            <option value="businessmodeltwo">
                              Business Model 2
                            </option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label
                            htmlFor="companyRevenue"
                            className="form-label"
                          >
                            Company Revenue
                          </label>
                          <input
                            type="text"
                            id="companyRevenue"
                            name="companyRevenue"
                            className="form-control"
                            placeholder="Enter Your Company Revenue"
                            value={formData.companyRevenue}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label
                            htmlFor="headquartersLocation"
                            className="form-label"
                          >
                            Headquarters Location
                          </label>
                          <input
                            type="text"
                            id="headquartersLocation"
                            name="headquartersLocation"
                            className="form-control"
                            placeholder="Enter Your Headquarters Location"
                            value={formData.headquartersLocation}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="linkedinPage" className="form-label">
                            Company LinkedIn Page <span>(Optional)</span>
                          </label>
                          <input
                            type="text"
                            id="linkedinPage"
                            name="linkedinPage"
                            className="form-control"
                            placeholder="Enter Your Company LinkedIn Page (Optional)"
                            value={formData.linkedinPage}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="specialties" className="form-label">
                            Specialties (Optional)
                          </label>
                          <select
                            id="specialties"
                            name="specialties"
                            className="form-control selectarrow"
                            value={formData.specialties}
                            onChange={(e) => handleChange(e)}
                          >
                            <option value="" disabled hidden>
                              Select Your Specialties (Optional)
                            </option>
                            <option value="specialties1">Specialties 1</option>
                            <option value="specialties2">Specialties 2</option>
                          </select>
                        </div>
                        <div className="col-md-12">
                          <label htmlFor="aboutCompany" className="form-label">
                            Job Description / Responsibilities (Optional)
                          </label>
                          <textarea
                            id="aboutCompany"
                            name="aboutCompany"
                            className="form-control aboutcompanytextbox"
                            placeholder="Enter a brief description of your company"
                            value={formData.aboutCompany}
                            onChange={(e) => handleChange(e)}
                          ></textarea>
                        </div>
                      </div>
                      <div className="d-flex justify-content-center mt-5 gap-3">
                        <button
                          type="button"
                          className="btn btn-outline-dark text-decoration-none preview_survey rounded-3 ft-15"
                          onClick={goToPreviousStep}
                          disabled={loading}
                        >
                          <i className="fa-solid fa-arrow-left ms-2"></i> Back
                        </button>
                        <button
                          type="button"
                          className="btn btn-dark text-decoration-none create_survey rounded-3 ft-15"
                          onClick={goToNextStep}
                          disabled={loading}
                        >
                          Next
                        </button>
                      </div>
                    </div>

                    {/* Step Three */}
                    <div
                      className={`stepthree ${
                        currentStep === 2 ? "active" : ""
                      }`}
                    >
                      {formData.previousEmployers.map((employer, index) => (
                        <div className="previousemployerbox mt-5" key={index}>
                          <div className="row g-4">
                            <div className="previousemployerboxhead relative">
                              <h2 className="ft-20 fw-600 text-red mt-4">
                                Previous Employer {index + 1}
                              </h2>
                              {index > 0 && (
                                <span
                                  className="previousemployerclose"
                                  onClick={() => removeEmployer(index)}
                                >
                                  <i className="bi bi-x-lg"></i>
                                </span>
                              )}
                            </div>

                            <div className="col-md-6">
                              <label
                                htmlFor={`companyName-${index}`}
                                className="form-label"
                              >
                                Company Name
                              </label>
                              <input
                                type="text"
                                id={`companyName-${index}`}
                                className="form-control"
                                placeholder="Enter Your Company Name"
                                value={employer.companyName}
                                onChange={(e) =>
                                  handleChange(
                                    e,
                                    index,
                                    "companyName",
                                    "previousEmployers"
                                  )
                                }
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                htmlFor={`jobTitle-${index}`}
                                className="form-label"
                              >
                                Job Title
                              </label>
                              <input
                                type="text"
                                id={`jobTitle-${index}`}
                                className="form-control"
                                placeholder="Enter Your Job Title"
                                value={employer.jobTitle}
                                onChange={(e) =>
                                  handleChange(
                                    e,
                                    index,
                                    "jobTitle",
                                    "previousEmployers"
                                  )
                                }
                              />
                            </div>
                            <div className="col-md-6">
                              <div className="row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor={`fromDate-${index}`}
                                    className="form-label"
                                  >
                                    From
                                  </label>
                                  <select
                                    id={`fromDate-${index}`}
                                    className="form-control selectarrow"
                                    value={employer.fromDate}
                                    onChange={(e) =>
                                      handleChange(
                                        e,
                                        index,
                                        "fromDate",
                                        "previousEmployers"
                                      )
                                    }
                                  >
                                    <option value="" disabled hidden>
                                      Select Start Year
                                    </option>
                                    <option value="2022">2022</option>
                                    <option value="2023">2023</option>
                                  </select>
                                </div>
                                <div className="col-md-6">
                                  <label
                                    htmlFor={`toDate-${index}`}
                                    className="form-label"
                                  >
                                    To
                                  </label>
                                  <select
                                    id={`toDate-${index}`}
                                    className="form-control selectarrow"
                                    value={employer.toDate}
                                    onChange={(e) =>
                                      handleChange(
                                        e,
                                        index,
                                        "toDate",
                                        "previousEmployers"
                                      )
                                    }
                                  >
                                    <option value="" disabled hidden>
                                      Select End Year
                                    </option>
                                    <option value="2024">2024</option>
                                    <option value="2025">2025</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <label
                                htmlFor={`location-${index}`}
                                className="form-label"
                              >
                                Location
                              </label>
                              <input
                                type="text"
                                id={`location-${index}`}
                                className="form-control"
                                placeholder="Enter Your Location"
                                value={employer.location}
                                onChange={(e) =>
                                  handleChange(
                                    e,
                                    index,
                                    "location",
                                    "previousEmployers"
                                  )
                                }
                              />
                            </div>
                            <div className="col-md-12">
                              <label
                                htmlFor={`jobDescription-${index}`}
                                className="form-label"
                              >
                                Job Description / Responsibilities (Optional)
                              </label>
                              <textarea
                                id={`jobDescription-${index}`}
                                className="form-control aboutcompanytextbox"
                                placeholder="Brief description of your job responsibilities"
                                value={employer.jobDescription}
                                onChange={(e) =>
                                  handleChange(
                                    e,
                                    index,
                                    "jobDescription",
                                    "previousEmployers"
                                  )
                                }
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className="col-lg-12">
                        <div className="anotheremployer_wrapper">
                          <a
                            href="#"
                            className="text-decoration-none anotehremployerbtn ft-16 fw-600 border-none mt-4"
                            onClick={addEmployer}
                          >
                            Another Employer
                          </a>
                        </div>
                      </div>
                      <div className="d-flex justify-content-center mt-5 gap-3">
                        <button
                          type="button"
                          className="btn btn-outline-dark text-decoration-none preview_survey rounded-3 ft-15"
                          onClick={goToPreviousStep}
                          disabled={loading}
                        >
                          <i className="fa-solid fa-arrow-left ms-2"></i> Back
                        </button>
                        <button
                          type="submit"
                          className="btn btn-dark text-decoration-none create_survey rounded-3 ft-15"
                          disabled={loading}
                        >
                          Submit
                        </button>
                        {/* <button
                        type="button"
                        className="btn btn-outline-dark text-decoration-none draft_survey rounded-3 ft-15"
                        onClick={() => handleSubmit(null, 2)}
                        disabled={loading}
                      >
                        <i className="bi bi-bookmark m-0"></i> Save as Draft
                      </button> */}
                      </div>
                    </div>
                    {error && (
                      <div className="text-danger text-center mt-3">
                        {error}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyProfile;
